<template>
  <div>
    <div class="fixed inset-0 flex items-end justify-center modal md:top-1/10" :class="params.wideLayout ? '' : 'md:items-start'">
      <div data-modal-close data-modal-overlay tabindex="-1" data-class-in="opacity-50" data-class-out="opacity-0" class="fixed inset-0 z-40 w-full transition-opacity duration-300 bg-black opacity-0 select-none"></div>
      <ellevio-web-info-modal :heading="params.modalName" :wideLayout="params.wideLayout">
        <div class="mb-8 text-xl" :class="params.donotusewysiwyg ? '' : 'wysiwyg'" v-html="params.content"></div>
        <div v-if="params.calculationHeading || params.calculation || params.link">
          <p class="mb-2">{{ params.calculationHeading }}</p>
          <p class="mb-2 font-futuraEfDemiBold">{{ params.calculation }}</p>
          <a v-if="params.link" :href="params.link" class="text-xl underline group">{{ params.linkText }}<ellevio-web-link-icon /></a>
        </div>
      </ellevio-web-info-modal>
    </div>
  </div>
</template>

<script>
import EllevioWebInfoModal from './InfoModal.vue'
import EllevioWebLinkIcon from '../structure/LinkIcon.vue'

export default {
  name: 'ellevio-web-modal-content',
  components: {
    EllevioWebInfoModal,
    EllevioWebLinkIcon
  },
  props: {
    params: {
      type: Object,
      default: () => {}
    }
  },
  methods: {}
}
</script>

<style scoped>
.modal {
  z-index: 1010;
}
</style>
